/* grid.tsx generated by @compiled/babel-plugin v0.35.0 */
import "./grid.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Children } from 'react';
var gutter = "var(--ds-space-negative-050, -4px)";
var listStyles = null;
var listItemStyles = null;
var Grid = function Grid(_ref) {
  var children = _ref.children,
    testId = _ref.testId,
    label = _ref['aria-label'];
  return /*#__PURE__*/React.createElement("ul", {
    "data-testid": testId,
    "aria-label": label,
    className: ax(["_18s8ze3t _1yt4ze3t _1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _12l2r5cr _ahbqr5cr"])
  }, Children.map(children, function (child) {
    return child && /*#__PURE__*/React.createElement("li", {
      className: ax(["_18s8ze3t _6rthu2gc _y4ti1b66 _bozg1b66"])
    }, child);
  }));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Grid;